import styled from "styled-components";
import { primaryThemeColor, secondaryThemeColor } from "../../assets/theme";

export const PageContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 2em;
`;

export const PageHeading = styled.h1`
    font-size: 3rem;
    text-align: center;
    margin: 1em 0 0.5em;
    @media (max-width: 50em) {
        font-size: 2.5em;
    }
`;

export const PageSubheading = styled.p`
    text-align: center;
    font-size: 1.2rem;
    margin-bottom: 2em;
    opacity: 0.8;
`;

export const SectionHeading = styled.h2`
    font-size: 2rem;
    margin: 2em 0 1em;
    padding-bottom: 0.5em;
    border-bottom: 3px solid ${secondaryThemeColor};
    display: flex;
    align-items: center;
    gap: 0.5em;
    @media (max-width: 50em) {
        font-size: 1.5em;
    }
`;

export const HoursBadge = styled.span`
    background: ${secondaryThemeColor};
    color: ${primaryThemeColor};
    padding: 0.25em 0.75em;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
`;

export const ProjectCard = styled.div`
    background: ${primaryThemeColor};
    border: 1px solid ${secondaryThemeColor};
    border-radius: 12px;
    padding: 1.5em;
    margin-bottom: 1.5em;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    }
`;

export const ProjectHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1em;
    margin-bottom: 1em;
`;

export const ProjectTitle = styled.h3`
    font-size: 1.4rem;
    margin: 0;
    flex: 1;
    min-width: 200px;
    @media (max-width: 50em) {
        font-size: 1.2em;
    }
`;

export const ProjectId = styled.span`
    background: ${secondaryThemeColor};
    color: ${primaryThemeColor};
    padding: 0.25em 0.6em;
    border-radius: 50%;
    font-size: 0.9rem;
    font-weight: bold;
    min-width: 1.5em;
    text-align: center;
`;

export const ProjectBrief = styled.p`
    line-height: 1.7;
    margin: 1em 0;
    text-align: justify;
`;

export const MetaGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1em;
    margin: 1.5em 0;
`;

export const MetaItem = styled.div`
    padding: 0.75em;
    background: rgba(128, 128, 128, 0.1);
    border-radius: 8px;
`;

export const MetaLabel = styled.span`
    display: block;
    font-size: 0.85rem;
    opacity: 0.7;
    margin-bottom: 0.25em;
    font-weight: 600;
`;

export const MetaValue = styled.span`
    font-size: 1rem;
`;

export const ReadingSection = styled.div`
    margin-top: 1.5em;
    padding-top: 1em;
    border-top: 1px solid rgba(128, 128, 128, 0.2);
`;

export const ReadingLabel = styled.h4`
    font-size: 1rem;
    margin: 0 0 0.75em;
    font-weight: 600;
`;

export const ReadingList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
`;

export const ReadingItem = styled.li`
    margin: 0;
`;

export const ReadingLink = styled.a`
    display: inline-block;
    padding: 0.4em 0.8em;
    background: rgba(128, 128, 128, 0.1);
    border-radius: 6px;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.2s ease;
    color: inherit;

    &:hover {
        background: ${secondaryThemeColor};
        color: ${primaryThemeColor};
    }
`;

export const DifficultyBadge = styled.span`
    display: inline-block;
    padding: 0.25em 0.6em;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    background: ${({ level }) => {
        switch (level) {
            case "Low to Moderate":
                return "#4caf50";
            case "Easy to Moderate":
                return "#8bc34a";
            case "Moderate":
                return "#ff9800";
            case "High":
                return "#f44336";
            default:
                return "#9e9e9e";
        }
    }};
    color: white;
`;
